export default __webpack_public_path__ + "static/media/kiosk-bg.b25d7a72.jpg";